import axios from "axios";
import React, { useEffect, useState } from "react";
import "./App.css";
import AppRoute from "./appRoute";
import { db, getTokenFirebase, onMessageListener } from "./firebase/firebase";
import { handleToastMessage } from "./js/handleToastMessage";
import audioFile from "./assets/audio/notification.mp3";
import { collection, getDocs, query, where } from "firebase/firestore";

function App() {
  const [increament, setIncreament] = useState(1);

  useEffect(() => {
    getTokenFirebase();
  }, []);

  useEffect(() => {
    updateAccountData();
  }, []);

  const updateAccountData = async () => {
    let account: any = localStorage.getItem("account");
    account = JSON.parse(account);
    const q = await query(
      collection(db, "Accounts"),
      where("email", "==", account?.email?.toLowerCase())
    );

    const querySnapshot = await getDocs(q);
    if (querySnapshot.docs.length > 0) {
      let _account = querySnapshot.docs[0].data();

      if (_account.isEnable === true || _account.isEnable === undefined) {
        if (querySnapshot.docs.length) {
          localStorage.setItem("account", JSON.stringify(_account));
        }
      }
    }
  };

  useEffect(() => {
    onMessageListener()
      .then((payload) => {
        console.log("payload message", payload);
        beep();
        handleToastMessage("success", payload?.data?.title, 15000);
        setIncreament((prev) => ++prev);
      })
      .catch((err) => console.log("failed: ", err));
  }, [increament]);

  function beep() {
    var snd = new Audio(audioFile);
    snd.play();
  }

  return (
    <>
      <AppRoute />
    </>
  );
}

export default App;
